import { Telcos } from "../../components";
import "./stylesCategoriaTelcos.scss";

export const CategoriaTelcos = () => (
  <div>
    <Telcos />
  </div>
);
